import { Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { useNoIndex } from "@/pages/NotFound";

const Shell = ({ children }) => {
  useNoIndex();
  return (
  <div className="min-h-screen bg-[#0B0F12] flex">
    <div className="hidden lg:flex w-1/2 relative">
      <img src="/img/logo.jpg" alt="SunCare Dental" className="absolute inset-0 w-full h-full object-cover" />
    </div>
    <div className="flex-1 flex flex-col items-center justify-center p-6 gap-6">
      <Link to="/" className="font-display text-2xl text-[#1AA5A0]" data-testid="auth-home-link">Dr. Cora Baltodano · Owner</Link>
      {children}
    </div>
  </div>
  );
};

export const SignInPage = () => (
  <Shell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp forceRedirectUrl="/admin" /></Shell>
);

export const SignUpPage = () => (
  <Shell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" forceRedirectUrl="/admin" /></Shell>
);
